import Swiper from "swiper";
import 'swiper/scss';
import {Navigation} from "swiper/modules";
import './content-elements/card-steps';
import {
    Dropdown,
    initTWE,
} from "tw-elements";

initTWE({ Dropdown});

new Swiper('.contentElementSwiper', {
    spaceBetween: 20,
    slidesPerView: 1.33,
    freeMode: true,
    breakpoints: {
        768: {
            slidesPerView: 4,

        },
    },
});

new Swiper('.productCategorySwiper', {
    spaceBetween: 20,
    slidesPerView: 1.33,
    freeMode: true,
    breakpoints: {
        768: {
            slidesPerView: 4,
        },
    },
});

new Swiper('.handPickedProductsSlider', {
    modules: [Navigation],
    slidesPerView: 1.33,
    spaceBetween: 20,
    navigation: {
        nextEl: '.handPickedProductsSlider .handPickedProducts-button-next',
        prevEl: '.handPickedProductsSlider .handPickedProducts-button-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 4,
        },
    },
});

jQuery(document).ready(function ($) {
    $('.btn-product-position button').on('click', function (e) {
        e.preventDefault();

        var button = $(this);
        var postId = button.attr('id');
        var targetCard = $("div[aria-labelledby='" + postId + "']");
        var parent = button.closest('.btn-product-position');

        // Hide all other cards
        $("div[aria-labelledby]").not(targetCard).addClass('hidden');
        $('.btn-product-position').not(parent).removeClass('btn-product-pos-active');

        // Toggle current card visibility
        targetCard.toggleClass('hidden');

        // Toggle btn-product-pos-active class on the container
        if (targetCard.hasClass('hidden')) {
            parent.removeClass('btn-product-pos-active');
        } else {
            parent.addClass('btn-product-pos-active');
        }
    });

    $(document).on('click', function (e) {
        if (
            !$(e.target).closest('.btn-product-position, [aria-labelledby]').length
        ) {
            $("div[aria-labelledby]").addClass('hidden');
            $('.btn-product-position').removeClass('btn-product-pos-active');
        }
    });
});